import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { toggleTutorialModal } from 'store/modules/modals';
import { Modal } from 'reactstrap';
import videoSvg from 'images/video-solid.svg';

class AlertMessageBottom extends Component {
  render() {
    const { content, styles, analytics, toggle, isShown } = this.props;
    return (
      <Fragment>
        <Modal className="works-modal" isOpen={isShown} toggle={toggle}>
          {content && (
            <iframe
              src="https://player.vimeo.com/video/330769634"
              className="play-modal-video"
              frameBorder="0"
              webkitallowfullscreen="true"
              mozallowfullscreen="true"
              allowFullScreen
              title="intro"
            />
          )}
          {styles && (
            <iframe
              src="https://player.vimeo.com/video/330769645"
              className="play-modal-video"
              frameBorder="0"
              webkitallowfullscreen="true"
              mozallowfullscreen="true"
              allowFullScreen
              title="intro"
            />
          )}
          {analytics && (
            <iframe
              src="https://player.vimeo.com/video/330769625"
              className="play-modal-video"
              frameBorder="0"
              webkitallowfullscreen="true"
              mozallowfullscreen="true"
              allowFullScreen
              title="intro"
            />
          )}
          <div className="play-close" onClick={toggle}>
            <div className="close-icon" />
          </div>
        </Modal>
        {!isShown && (
          <div className="a-message-bottom">
            <div className="a-message-bottom__inner">
              <span className="icon-outline">
                <img src={videoSvg} alt="acc" />
              </span>
              <span className="m-l-15 std-text white">
                Don't know where to start? We've prepared a tutorial for you!
              </span>
              <a
                className="std-text white pointer watch-tutorial"
                onClick={toggle}>
                Watch tutorial
              </a>
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  isShown: state.modals.tutorialVisibility,
});

const mapDispatchToProps = {
  toggle: toggleTutorialModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlertMessageBottom);



// WEBPACK FOOTER //
// ./src/components/AlertBottomMessage/AlertBottomMessage.js